'use strict';

import {reverseUrl} from 'utils/django';


export default {
	method: 'POST',
	getUrl: getUrl,
};


function getUrl($incident) {
	return reverseUrl('incidents:incident-label-list', {
		incident_uuid: $incident.uuid,
	});
}
